<template>
  <Headers> </Headers>
  <div :class="[deviceType, 'progressContainer']">
    <PogressBarStep :cardName="prop.cardName" :currentStep="9">
    </PogressBarStep>
    <Form
      @submit="onSubmit"
      :validation-schema="schema"
      @invalid-submit="onInvalidSubmit"
    >
      <div :class="[deviceType, 'inner']">
        <div :class="[deviceType, 'content']">
          <div :class="[deviceType, 'separator']">
            <div class="radio">
              <p class="description">
                {{ t("ccOnBoarding.supplementary.question1") }}
              </p>
              <div class="agree">
                <section class="radioClass">
                  <RadioButton
                    v-for="option in hrcQuestionnaireEnum"
                    :key="option.value"
                    :label="option.label"
                    :values="option.value"
                    class="radioHorizontal"
                    field="question1"
                    id="q1"
                    :selected-value="prop.supplementary.question1"
                    :label-class="'radioLabel'"
                    @selected="question1Selection"
                    :class="{ 'display-flex': true }"
                  />
                </section>
              </div>
              <pre class="help" v-if="!errorMessage"> {{ errorMessage }}</pre>
              <pre class="help" v-else-if="error && errorMessage">{{
                errorMessage
              }}</pre>
              <pre class="help" v-else>&nbsp</pre>
            </div>
            <div v-if="prop.supplementary.question1 == 'Yes'">
              <div :class="[deviceType, 'container']">
                <div :class="[deviceType, 'flex_third', 'fullWidth']">
                  <DropDown
                    v-model="supplementary.title"
                    :selectedOption="supplementary.title"
                    :options="titleList"
                    :value="titleList"
                    field="title"
                    :placeholder="t('ccOnBoarding.supplementary.title')"
                  />
                </div>
                <div :class="[deviceType, 'flex_inputText']">
                  <InputText
                    class="inputcomponent"
                    v-model="supplementary.fullName"
                    field="fullName"
                    :required="false"
                    :placeholder="t('ccOnBoarding.supplementary.fullName')"
                    :max-length="100"
                    :autocomplete="'new-password'"
                    @keydown="handleNameKeyDown"
                  />
                </div>
              </div>
              <div :class="[deviceType, 'container']">
                <div :class="[deviceType, 'flex_third', 'fullWidth']">
                  <DropDown
                    v-model="supplementary.idType"
                    :selectedOption="supplementary.idType"
                    :options="idTypeList.slice(0, 2)"
                    :value="idTypeList.slice(0, 2)"
                    field="idType"
                    :placeholder="t('ccOnBoarding.supplementary.idType')"
                  />
                </div>
                <div :class="[deviceType, 'flex_inputText']">
                  <InputText
                    class="inputcomponent"
                    v-model="supplementary.idNo"
                    field="idNo"
                    :required="false"
                    :placeholder="
                      supplementary.idType == '1'
                        ? t('ccOnBoarding.supplementary.passportNumber')
                        : supplementary.idType != '1' &&
                          supplementary.idType != ''
                        ? t('ccOnBoarding.supplementary.ic')
                        : t('ccOnBoarding.supplementary.icPassportNumber')
                        ? t('ccOnBoarding.supplementary.icPassportNumber')
                        : t('ccOnBoarding.supplementary.icPassportNumber')
                    "
                    :autocomplete="'new-password'"
                    :max-length="computedMaxLength"
                    :pattern="computedPattern"
                    :number="
                      prop.supplementary.idType === '0' ? 'true' : 'false'
                    "
                    @keydown="handleKeyDown"
                    :disabled="prop.supplementary.idType === ''"
                    :clear="isClear"
                    :type="'text'"
                    :inputmode="
                      prop.supplementary.idType != '1' ? 'numeric' : 'text'
                    "
                  />
                </div>
              </div>
              <div :class="[deviceType, 'container']">
                <div :class="[deviceType, 'full']">
                  <InputText
                    class="inputcomponent"
                    v-model="prop.supplementary.nameOnCard"
                    field="nameOnCard"
                    :required="false"
                    :placeholder="t('ccOnBoarding.supplementary.nameOnCard')"
                    :max-length="19"
                    :autocomplete="'new-password'"
                    @keydown="handleNameCardKeyDown"
                  />
                </div>
              </div>

              <div :class="[deviceType, 'container']">
                <div :class="[deviceType, 'flex_half']">
                  <div :class="[deviceType, 'margin']">
                    <DropDown
                      v-model="supplementary.nationality"
                      :selectedOption="supplementary.nationality"
                      :options="nationalityList"
                      :value="nationalityList"
                      field="nationality"
                      :placeholder="t('ccOnBoarding.supplementary.nationality')"
                      :default="true"
                      :default-value="defaultNationality"
                      :disabled="supplementary.idType == '0'"
                    />
                  </div>
                </div>
                <div :class="[deviceType, 'flex_half']">
                  <DatePicker
                    :class="[deviceType, 'dates']"
                    :disabled="prop.supplementary.idType != '1'"
                    field="dob"
                    v-model:date-selected="prop.supplementary.dob"
                    :placeholder="t('ccOnBoarding.supplementary.dob')"
                    :defaultValue="
                      prop.supplementary.idType != '1'
                        ? computedDob
                        : year + month + day
                    "
                  />
                </div>
              </div>

              <div :class="[deviceType, 'container']">
                <div :class="[deviceType, 'flex_half']">
                  <div :class="[deviceType, 'margin']">
                    <DropDown
                      v-model="supplementary.gender"
                      :selectedOption="supplementary.gender"
                      :options="genderList"
                      :value="genderList"
                      field="gender"
                      :placeholder="t('ccOnBoarding.supplementary.gender')"
                    />
                  </div>
                </div>
                <div :class="[deviceType, 'flex_half']">
                  <DropDown
                    v-model="supplementary.race"
                    :selectedOption="supplementary.race"
                    :options="raceList"
                    :value="raceList"
                    field="race"
                    :placeholder="t('ccOnBoarding.supplementary.race')"
                  />
                  <div
                    v-if="prop.supplementary.race == '004'"
                    :class="[deviceType, 'dropDown']"
                    style="margin-top: 10px"
                  >
                    <InputText
                      class="inputcomponent"
                      v-model="prop.supplementary.otherRace"
                      field="otherRace"
                      :required="false"
                      :placeholder="t('ccOnBoarding.supplementary.otherRace')"
                      :max-length="20"
                      :autocomplete="'new-password'"
                    />
                  </div>
                </div>
              </div>
              <div :class="[deviceType, 'container']">
                <div :class="[deviceType, 'flex_half']">
                  <div :class="[deviceType, 'margin']">
                    <InputText
                      class="inputcomponent"
                      v-model="prop.supplementary.motherMaidenName"
                      field="motherMaidenName"
                      :required="false"
                      :placeholder="
                        t('ccOnBoarding.supplementary.motherMaidenName')
                      "
                      :max-length="100"
                      :autocomplete="'new-password'"
                      @keydown="handleNameKeyDown"
                    />
                  </div>
                </div>
                <div :class="[deviceType, 'flex_half']">
                  <DropDown
                    v-model="supplementary.relationship"
                    :selectedOption="supplementary.relationship"
                    :options="relationshipList"
                    :value="relationshipList"
                    field="relationship"
                    :placeholder="t('ccOnBoarding.supplementary.relationship')"
                  />
                </div>
              </div>

              <div :class="[deviceType, 'separator']">
                <div :class="[deviceType, 'container']">
                  <div :class="[deviceType, 'full']">
                    <InputText
                      class="inputcomponent"
                      v-model="prop.supplementary.email"
                      field="email"
                      :required="false"
                      :placeholder="t('ccOnBoarding.supplementary.email')"
                      :max-length="50"
                      :autocomplete="'new-password'"
                      :noCapital="true"
                    />
                  </div>
                </div>
                <div :class="[deviceType, 'container3']">
                  <div :class="[deviceType, 'flex_third']">
                    <DropDown
                      v-model="prop.supplementary.mobileCountryCode"
                      :selectedOption="prop.supplementary.mobileCountryCode"
                      :options="mobileCountryCodeList.slice(0, 2)"
                      :value="mobileCountryCodeList.slice(0, 2)"
                      :default="true"
                      :default-value="'60'"
                      field="countryCode"
                      :placeholder="
                        deviceType != 'Mobile'
                          ? t('ccOnBoarding.basicInformation.countryCode')
                          : ''
                      "
                      :disabled="otp.supplementaryOtp.status == 'verified'"
                      :is-country-code="true"
                    />
                  </div>
                  <div :class="[deviceType, 'flex_inputText']">
                    <InputText
                      class="inputcomponent"
                      v-model="prop.supplementary.mobileNo"
                      field="mobileNo"
                      :required="false"
                      :placeholder="t('ccOnBoarding.basicInformation.mobileNo')"
                      :max-length="
                        prop.supplementary.mobileCountryCode == '65' ? 9 : 10
                      "
                      :min-length="
                        prop.supplementary.mobileCountryCode == '65' ? 8 : 9
                      "
                      :autocomplete="'new-password'"
                      onkeypress="return (event.charCode >= 48 && event.charCode <= 57)"
                      :number="'true'"
                      :type="'text'"
                      :pattern="'[0-9]*'"
                      :inputmode="'numeric'"
                      :trim="true"
                      :disabled="otp.supplementaryOtp.status == 'verified'"
                    />
                  </div>
                </div>
              </div>

              <div :class="[deviceType, 'separator']">
                <div :class="[deviceType, 'container']">
                  <div :class="[deviceType, 'flex_half']">
                    <div :class="[deviceType, 'margin']">
                      <InputText
                        class="inputcomponent"
                        v-model="supplementary.residentialAddress1"
                        field="residentialAddress1"
                        :required="false"
                        :placeholder="
                          t('ccOnBoarding.supplementary.residentialAddress1')
                        "
                        :max-length="50"
                        :autocomplete="'new-password'"
                      />
                    </div>
                  </div>
                  <div :class="[deviceType, 'flex_half']">
                    <InputText
                      class="inputcomponent"
                      v-model="supplementary.residentialAddress2"
                      field="residentialAddress2"
                      :required="false"
                      :placeholder="
                        t('ccOnBoarding.supplementary.residentialAddress2')
                      "
                      :max-length="50"
                      :autocomplete="'new-password'"
                    />
                  </div>
                </div>
                <div :class="[deviceType, 'container']">
                  <div :class="[deviceType, 'flex_half']">
                    <div :class="[deviceType, 'margin']">
                      <InputText
                        class="inputcomponent"
                        v-model="supplementary.residentialAddress3"
                        field="residentialAddress3"
                        :required="false"
                        :placeholder="
                          t('ccOnBoarding.supplementary.residentialAddress3')
                        "
                        :max-length="50"
                        :autocomplete="'new-password'"
                      />
                    </div>
                  </div>
                  <div :class="[deviceType, 'flex_half']">
                    <InputText
                      v-bind="$attrs"
                      class="inputcomponent"
                      v-model="prop.supplementary.postCode"
                      field="postCode"
                      :postCode="true"
                      :required="false"
                      :placeholder="t('ccOnBoarding.supplementary.postCode')"
                      :max-length="5"
                      :autocomplete="'new-password'"
                      onkeypress="return (event.charCode >= 48 && event.charCode <= 57)"
                      :number="'true'"
                      :type="'text'"
                      :inputmode="'numeric'"
                      :pattern="'[0-9]*'"
                    />
                  </div>
                </div>
                <div :class="[deviceType, 'container']">
                  <div :class="[deviceType, 'flex_half']">
                    <div :class="[deviceType, 'margin']">
                      <InputText
                        :disabled="true"
                        class="inputcomponent"
                        v-model="prop.supplementary.city"
                        :value="prop.supplementary.city"
                        field="city"
                        :required="false"
                        :placeholder="t('ccOnBoarding.supplementary.city')"
                        :autocomplete="'new-password'"
                      />
                    </div>
                  </div>

                  <div :class="[deviceType, 'flex_half']">
                    <InputText
                      class="inputcomponent"
                      :disabled="true"
                      v-model="prop.supplementary.state"
                      :value="prop.supplementary.state"
                      field="state"
                      :required="false"
                      :placeholder="t('ccOnBoarding.supplementary.state')"
                      :max-length="21"
                      :autocomplete="'new-password'"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="line"></div>
          <div :class="[deviceType, 'buttoncontainer']">
            <button
              v-if="prop.summarySetting.supplementaryCardDetailsJump == false"
              :class="[deviceType, 'left-button']"
              type="button"
              @click="handleBack"
            >
              {{ t("ccOnBoarding.back") }}
            </button>
            <div v-else :class="[deviceType, 'left-button:disabled']"></div>
            <button
              v-if="prop.summarySetting.supplementaryCardDetailsJump == false"
              :disabled="isBtnDisabled"
              :class="[deviceType, 'right-button']"
            >
              {{ t("ccOnBoarding.next") }}
            </button>
            <button
              v-else
              :class="[deviceType, 'summary-button']"
              :disabled="isBtnDisabled"
            >
              {{ t("ccOnBoarding.backToSummary") }}
            </button>
          </div>
        </div>
      </div>
    </Form>
  </div>
  <div v-if="prop.overlay" class="overlay">
    <div class="text-center flex-container">
      <p class="loading">
        <b>{{ t("ccOnBoarding.uploadDocument.loading") }}</b>
        <!-- <b>Submit Fail</b> -->
      </p>
      <br />
      <div class="spinner-border" role="status">
        <span class="sr-only">{{
          t("ccOnBoarding.uploadDocument.loading2")
        }}</span>
      </div>
      <br />
      <br />
      <p class="loading">
        <b>{{ t("ccOnBoarding.uploadDocument.loading2") }}</b>
      </p>
      <br />
      <br />
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  ref,
  computed,
  watch,
  onBeforeMount,
  onMounted,
  type PropType,
} from "vue";
import Headers from "./components/Headers.vue";
import PogressBarStep from "./components/ProgressBarStep.vue";
import DropDown from "./components/NewDropDownComponent.vue";
import InputText from "./components/NewInputTextComponent.vue";
import i18n from "@/plugin/i18n";
import { Form } from "vee-validate";
import router from "@/router";
import MasterService from "@/service/restfulService/CCOnboardMasterService";
import { deviceDetect } from "mobile-device-detect";
import type { Supplementary } from "@/interface/FormCC";
import DatePicker from "./components/DatePickerComponent.vue";
import hrcQuestionnaireEnum from "@/enum/HRCQuestionnaireEnum";
import RadioButton from "./components/NewRadioButtonComponent.vue";
import Swal from "sweetalert2";
import type FormCCOtp from "@/interface/FormCCOtp";
import type { SummarySetting } from "@/interface/FormCC";

const prop = defineProps({
  supplementary: {
    type: Object as PropType<Supplementary>,
    required: true,
  },
  otp: {
    type: Object as PropType<FormCCOtp>,
    required: true,
  },
  mobileNo: {
    type: String,
    required: true,
  },
  cardName: {
    type: String,
    required: true,
  },
  overlay: {
    type: Boolean,
    required: true,
  },
  summarySetting: {
    type: Object as PropType<SummarySetting>,
    required: true,
  },
});

const { t } = i18n.global;
const deviceType = ref("");
const isClear = ref("false");
const error = ref(true);
const errorMessage = ref("");
const dateParts = ref(prop.supplementary.dob.split("/"));
const year = ref("");
const month = ref("");
const day = ref("");

//List
let titleList = ref([]);
let idTypeList = ref([]);
let nationalityList = ref([]);
let genderList = ref([]);
let raceList = ref([]);
let mobileCountryCodeList = ref([]);
let relationshipList = ref([]);
const emit = defineEmits(["submit", "nextStep", "jumpStep", "previousStep"]);

if (prop.supplementary.dob != "") {
  year.value = dateParts.value[2].substring(2, 4);
  month.value = dateParts.value[1];
  day.value = dateParts.value[0];
}
onMounted(() => {
  const { isMobile, isTablet } = deviceDetect();

  if (isMobile) {
    deviceType.value = "Mobile";
  } else if (isTablet) {
    deviceType.value = "Tablet";
  } else {
    deviceType.value = "Desktop";
  }
});

onBeforeMount(() => {
  MasterService.getMasterData()
    .then((res) => {
      titleList.value = res.data.titleType;
      idTypeList.value = res.data.idType;
      genderList.value = res.data.genderType;
      raceList.value = res.data.raceType;
      mobileCountryCodeList.value = res.data.mobileNoCountryCode;
      relationshipList.value = res.data.relativeType;
    })
    .catch((e) => {});
  MasterService.getNationalityData()
    .then((res) => {
      nationalityList.value = res.data.nationalityType;
    })
    .catch((e) => {});
  if (prop.supplementary.idType == "") {
    prop.supplementary.idType = "0";
  }

  if (
    prop.summarySetting.supplementaryCardDetailsJump == true &&
    !prop.supplementary.nameOnCard
  ) {
    prop.supplementary.question1 = "No";
  }
});

const computedMaxLength = computed(() =>
  prop.supplementary.idType === "0" ? 12 : 12
);

const computedPattern = computed(() =>
  prop.supplementary.idType === "0" ||
  prop.supplementary.idType === "2" ||
  prop.supplementary.idType === "3"
    ? /^\d+$/
    : /^[A-Za-z]\d{8}$/
);

const computedDobTwo = computed(() => {
  if (
    prop.supplementary.idNo.length == 12 &&
    prop.supplementary.idType != "1"
  ) {
    return prop.supplementary.idNo.substring(0, 2);
  }
  return "";
});

const currentYear = parseInt(
  new Date().getFullYear().toString().substring(2, 4),
  10
);

const defaultNationality = computed(() => {
  return prop.supplementary.idType === "0"
    ? "MY"
    : prop.supplementary.nationality;
});

const computedDob = computed(() => {
  if (
    prop.supplementary.idNo.length == 12 &&
    prop.supplementary.idType != "1"
  ) {
    return prop.supplementary.idNo.substring(0, 6);
  }
  return "";
});

//PostCode for part1
async function postCodeData() {
  if (prop.supplementary.postCode.length >= 5) {
    try {
      const res = await MasterService.checkPostCode(
        prop.supplementary.postCode
      );
      prop.supplementary.city = res.data.responseModel.city;
      prop.supplementary.state = res.data.responseModel.state;
      schema.value.postCode =
        "minLengthNumber:5|maxLengthNumber:5|requiredNumber|numberFormat";
    } catch (e) {
      prop.supplementary.city = "";
      prop.supplementary.state = "";
      schema.value.postCode =
        "minLengthNumber:5|maxLengthNumber:10|requiredNumber|invalidPostCode|numberFormat";
    }
  }
}

const getValue = computed(async () => {
  if (prop.supplementary.postCode.length < 5) {
    prop.supplementary.city = "";
    prop.supplementary.state = "";
  } else if (prop.supplementary.postCode.length >= 5) {
    await postCodeData();
  }

  return {
    city: prop.supplementary.city,
    state: prop.supplementary.state,
  };
});

const cityValue = ref("");
const stateValue = ref("");

async function updateValues() {
  const newValues = await getValue.value;
  cityValue.value = newValues.city;
  stateValue.value = newValues.state;
}

watch(getValue, updateValues, { immediate: true });

const question1Selection = (option: string) => {
  prop.supplementary.question1 = option;
  error.value = false;
};

const schema = computed(() => {
  const question1 = prop.supplementary.question1 == "Yes";
  const idNoIcFormat = prop.supplementary.idType == "0";
  const idNoPassportFormat = prop.supplementary.idType == "1";
  const countryCode = prop.supplementary.mobileCountryCode == "60";
  const nationalityMY =
    prop.supplementary.nationality == "MY" && prop.supplementary.idType == "1";
  const minAge = ref("18");
  return {
    question1: "required",
    title: question1 ? "required" : "",
    fullName: question1 ? "required|nameFormat" : "",
    idType: question1 ? "required" : "",
    idNo: question1
      ? idNoIcFormat
        ? "required|minLengthNumber:12|icNo|numberFormat"
        : idNoPassportFormat
        ? "required|minLengthNumber:8|maxLengthNumber:12"
        : ""
      : "",
    nameOnCard: question1 ? "required" : "",
    nationality: question1
      ? nationalityMY
        ? "invalidNationality|required"
        : "required"
      : "",
    dob: question1 ? `required|minAge:${minAge.value}` : "",
    gender: question1 ? "required" : "",
    race: question1 ? "required" : "",
    otherRace: question1
      ? prop.supplementary.race == "004"
        ? "required"
        : ""
      : "",
    motherMaidenName: question1 ? "required|nameFormat" : "",
    relationship: question1 ? "required" : "",
    email: question1 ? "required|email" : "",
    mobileNo: question1
      ? countryCode
        ? `requiredNumber|minLengthNumber:9|maxLengthNumber:10|numberFormat|sameMobile:${
            prop.mobileNo
          },${
            prop.supplementary.mobileCountryCode + prop.supplementary.mobileNo
          }`
        : `requiredNumber|minLengthNumber:8|maxLengthNumber:9|numberFormat|sameMobile:${
            prop.mobileNo
          },${
            prop.supplementary.mobileCountryCode + prop.supplementary.mobileNo
          }`
      : "",
    residentialAddress1: question1 ? "required" : "",
    // residentialAddress2: question1 ? "required" : "",
    postCode: question1
      ? "minLengthNumber:5|maxLengthNumber:10|requiredNumber|numberFormat"
      : "",
  };
});

const isBtnDisabled = computed(() => {
  const isSupp = prop.supplementary.question1 == "Yes";
  return (
    prop.supplementary.question1.length == 0 ||
    (isSupp && prop.supplementary.title.length == 0) ||
    (isSupp && prop.supplementary.fullName.length == 0) ||
    (isSupp && prop.supplementary.idType.length == 0) ||
    (isSupp && prop.supplementary.idNo.length == 0) ||
    (isSupp && prop.supplementary.nameOnCard.length == 0) ||
    (isSupp && prop.supplementary.nationality.length == 0) ||
    (isSupp && prop.supplementary.dob.length == 0) ||
    (isSupp && prop.supplementary.gender.length == 0) ||
    (isSupp && prop.supplementary.race.length == 0) ||
    (isSupp &&
      prop.supplementary.race == "004" &&
      prop.supplementary.otherRace.length == 0) ||
    (isSupp && prop.supplementary.motherMaidenName.length == 0) ||
    (isSupp && prop.supplementary.relationship.length == 0) ||
    (isSupp && prop.supplementary.mobileNo.length == 0) ||
    (isSupp && prop.supplementary.mobileCountryCode.length == 0) ||
    (isSupp && prop.supplementary.residentialAddress1.length == 0) ||
    // (isSupp && prop.supplementary.residentialAddress2.length == 0) ||
    (isSupp && prop.supplementary.postCode.length == 0)
  );
});

const handleKeyDown = (event: KeyboardEvent) => {
  const isDigit = /^[0-9]$/.test(event.key);
  const isArrowKey = /^Arrow(Left|Right)$/.test(event.key);

  const isIOSArrowKey =
    event.key === "UIKeyInputLeftArrow" || event.key === "UIKeyInputRightArrow";
  const isAndroidArrowKey =
    event.key === "ArrowLeft" || event.key === "ArrowRight";

  const isDeleteKey = event.key === "Delete";
  const isBackspace = event.key === "Backspace";
  const isTabKey = event.key === " Tab";
  const isSymbol = /[^\w\d_]/.test(event.key); // true for symbol input

  if (
    (prop.supplementary.idType === "0" ||
      prop.supplementary.idType === "1" ||
      prop.supplementary.idType === "2" ||
      prop.supplementary.idType === "3") &&
    isSymbol &&
    !isBackspace &&
    !(isArrowKey || isIOSArrowKey || isAndroidArrowKey) &&
    !isDeleteKey &&
    !isTabKey
  ) {
    event.preventDefault();
  }
};

const handleNameKeyDown = (event: KeyboardEvent) => {
  const isSymbol = /^[a-zA-Z@#()_:\/.,'\-\s]+$/.test(event.key);
  const isDeleteKey = event.key === "Delete";
  const isBackspace = event.key === "Backspace";
  const isTabKey = event.key === " Tab";
  const isArrowKey = /^Arrow(Left|Right)$/.test(event.key);

  const isIOSArrowKey =
    event.key === "UIKeyInputLeftArrow" || event.key === "UIKeyInputRightArrow";
  const isAndroidArrowKey =
    event.key === "ArrowLeft" || event.key === "ArrowRight";

  if (
    !isSymbol &&
    !isBackspace &&
    !(isArrowKey || isIOSArrowKey || isAndroidArrowKey) &&
    !isDeleteKey &&
    !isTabKey
  ) {
    event.preventDefault();
  }
};

const handleNameCardKeyDown = (event: KeyboardEvent) => {
  const isSymbol = /[^\sa-zA-Z]/.test(event.key);
  const isDeleteKey = event.key === "Delete";
  const isBackspace = event.key === "Backspace";
  const isTabKey = event.key === " Tab";
  const isArrowKey = /^Arrow(Left|Right)$/.test(event.key);

  const isIOSArrowKey =
    event.key === "UIKeyInputLeftArrow" || event.key === "UIKeyInputRightArrow";
  const isAndroidArrowKey =
    event.key === "ArrowLeft" || event.key === "ArrowRight";

  if (
    isSymbol &&
    !isBackspace &&
    !(isArrowKey || isIOSArrowKey || isAndroidArrowKey) &&
    !isDeleteKey &&
    !isTabKey
  ) {
    event.preventDefault();
  }
};

const onInvalidSubmit = () => {
  errorMessage.value = t("ccOnBoarding.employmentDetails.error");
};

const onSubmit = () => {
  emit("submit");
};

const handleBack = () => {
  emit("previousStep");
};

let previousValue: string | null = null;
watch(
  () => prop.supplementary.idType,
  (newValue) => {
    if (newValue) {
      isClear.value = previousValue === "0" ? "1" : "0";
      previousValue = isClear.value;
    }
    if (newValue == "1" && prop.supplementary.nationality == "MY") {
      prop.supplementary.nationality = "";
    }
  }
);

watch(
  () => prop.supplementary.mobileCountryCode,
  (newValue) => {
    if (newValue) {
      prop.supplementary.mobileNo = "";
    }
  }
);

watch(
  () => prop.supplementary.question1,
  (newValue) => {
    if (newValue) {
      prop.supplementary.title = "";
      prop.supplementary.fullName = "";
      prop.supplementary.idType = "";
      prop.supplementary.idNo = "";
      prop.supplementary.nameOnCard = "";
      prop.supplementary.nationality = "";
      prop.supplementary.dob = "";
      prop.supplementary.gender = "";
      prop.supplementary.race = "";
      prop.supplementary.otherRace = "";
      prop.supplementary.motherMaidenName = "";
      prop.supplementary.relationship = "";
      prop.supplementary.email = "";
      prop.supplementary.mobileCountryCode = "";
      prop.supplementary.relationship = "";
      prop.supplementary.mobileNo = "";
      prop.supplementary.residentialAddress1 = "";
      prop.supplementary.residentialAddress2 = "";
      prop.supplementary.residentialAddress3 = "";
      prop.supplementary.postCode = "";
      prop.supplementary.city = "";
      prop.supplementary.state = "";
    }
  }
);
</script>

<style scoped>
.progressContainer {
  max-width: 1440px;
  margin: auto;
  padding: 4% 8%;
  background: #fff;
}

.radioClass {
  display: flex;
  align-items: flex-end;
}

.content {
  margin-top: 40px;
  padding: 0 8%;
}

.container,
.container3 {
  display: flex;
  width: 100%;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  padding: 0;
  margin-bottom: 14px;
}

.help {
  color: red;
  margin-bottom: 0px;
  font: 400 16px/130% "Outfit", sans-serif;
  word-wrap: break-word;
  white-space: pre-wrap;
}

.flex_half {
  width: 50%;
}

.separator {
  margin-bottom: 37px;
}

.summary-button {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: none;
  background-image: var(
    --gradient-set-active,
    linear-gradient(120deg, #7653ff -4.72%, #8e4eff -3.32%, #ea27c2 45.42%)
  );
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  flex: 0 0 100%;
  transition: background-color 0.3s ease;
}

.summary-button:hover {
  background-image: linear-gradient(
      120deg,
      rgba(255, 255, 255, 0.4),
      rgba(255, 255, 255, 0.4)
    ),
    var(
      --gradient-set-active,
      linear-gradient(120deg, #7653ff -4.72%, #8e4eff -3.32%, #ea27c2 45.42%)
    );
}

.summary-button:active {
  background-image: linear-gradient(
      120deg,
      rgba(0, 0, 0, 0.3),
      rgba(0, 0, 0, 0.3)
    ),
    var(
      --gradient-set-active,
      linear-gradient(120deg, #7653ff -4.72%, #8e4eff -3.32%, #ea27c2 45.42%)
    );
}

.summary-button:disabled {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: none;
  background: #dedede;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  flex: 0 0 100%;
}

.right-button {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: none;
  background-image: var(
    --gradient-set-active,
    linear-gradient(120deg, #7653ff -4.72%, #8e4eff -3.32%, #ea27c2 45.42%)
  );
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  flex: 0 0 25%;
}

.left-button {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: 1px solid #cb03bc;
  background-color: white;
  font-size: 14px;
  font-weight: 500;
  color: #cb03bc;

  flex: 0 0 25%;
}

.right-button:disabled {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: none;
  background: #dedede;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  flex: 0 0 25%;
}

.inputText {
  margin-bottom: 10px;
}

.line {
  border-bottom: 1px solid #e4e4e4;
}

.buttoncontainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 24px;
}

/* .left-button {
  flex: 0 0 15%;
} */

.agree {
  display: flex;
  align-items: flex-start;
}

/* .radioClass {
  display: flex;
} */

.radioHorizontal {
  margin-right: 24px !important;
  color: rgba(0, 0, 0, 0.38);
  margin-bottom: 5px;
}

.description {
  color: #212121;
  font: 500 16px/130% "Outfit";
  margin-bottom: 10px;
  text-align: left;

  position: relative;
  align-self: stretch;
}

.brLine {
  margin-bottom: 8px;
}

.flex_third {
  width: 30%;
}

.flex_inputText {
  width: 70%;
}

.full {
  width: 100%;
}

.radio {
  margin-bottom: 15px;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 110%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  will-change: transform, opacity;
  transform: translateZ(0);
  overflow-y: hidden;
  transition: top 0.3s;
}

.loading {
  margin-bottom: 0;
  font-family: "Outfit";
  color: white;
}

.spinner-border {
  width: 5rem;
  height: 5rem;
  color: white;
}

.flex-container {
  left: 0;
  margin: auto;
  position: absolute;
  text-align: center;
  top: 35%;
  right: 30%;
  left: 30%;
}

@media (max-width: 700px) {
  .container:is(.Desktop, .Tablet),
  .container3:is(.Desktop, .Tablet) {
    flex-direction: column;
    gap: 14px;
  }

  .flex_dropdown:is(.Desktop, .Tablet),
  .flex_inputText:is(.Desktop, .Tablet) {
    width: 100%;
  }
  .flex_half:is(.Desktop, .Tablet) {
    width: 100%;
  }

  .flex_third:is(.Desktop, .Tablet) {
    width: 100%;
  }

  .buttoncontainer:is(.Desktop, .Tablet) {
    gap: 10px;
  }

  .left-button:is(.Desktop, .Tablet) {
    flex: 0 0 30%;
  }

  .right-button:is(.Desktop, .Tablet) {
    flex: 0 0 68%;
  }

  .right-button:disabled:is(.Desktop, .Tablet) {
    flex: 0 0 68%;
  }

  .summary-button:is(.Desktop, .Tablet) {
    flex: 0 0 100%;
  }

  .summary-button:disabled:is(.Desktop, .Tablet) {
    flex: 0 0 100%;
  }

  .separator:is(.Desktop, .Tablet) {
    margin-bottom: 0;
  }
}

.separator .container {
  max-width: none;
}
.content2:is(.Mobile),
.content2:is(.Mobile) {
  margin-top: 0px;
}
.content:is(.Mobile) {
  padding: 0;
}

.progressContainer:is(.Mobile) {
  max-width: 1440px;
  margin: auto;
  padding: 0;
  background: #fff;
}

.inner:is(.Mobile) {
  padding: 20px 20px 0 20px;
}

.container:is(.Mobile) {
  flex-direction: column;
  gap: 14px;
}

.container3:is(.Mobile) {
  max-width: none !important;
}

.flex_dropdown:is(.Mobile),
.flex_inputText:is(.Mobile) {
  width: 100%;
}
.flex_half:is(.Mobile) {
  width: 100%;
}

.flex_third:is(.Mobile) {
  width: 30%;
}

.flex_third.fullWidth:is(.Mobile) {
  width: 100%;
}

.buttoncontainer:is(.Mobile) {
  gap: 10px;
  margin-bottom: 24px;
}

.left-button:is(.Mobile) {
  flex: 0 0 30%;
}

.right-button:is(.Mobile) {
  flex: 0 0 68%;
}

.right-button:disabled:is(.Mobile) {
  flex: 0 0 68%;
}

.summary-button:is(.Mobile) {
  flex: 0 0 100%;
}

.summary-button:disabled:is(.Mobile) {
  flex: 0 0 100%;
}

.separator:is(.Mobile) {
  margin-bottom: 0;
}

.content2 {
  margin-top: 40px;
  padding: 0 8%;
}

/* .margin:is(.Mobile) {
  margin-bottom: 10px;
} */
</style>
